module.exports = __webpack_public_path__ + "img/9788954613866.29e1a7c2.jpg";